<template>
    <div class="wrapper">
        <!-- <div class="top">
            <div class="topContainer">
                <div class="left" style="float:left;">
                    <span class="tag">{{time}}</span>
                </div>
                <div class="right">
                    <span :style="'background-color:'+themColor" class="loginAdmin" @click="toLiTiXuJiao"> 登 &nbsp;&nbsp; 录 </span>
                </div>
            </div>
        </div> -->
        <div class="header" style="padding: 0;">
           <div class="leftHeader">
                <div class="org-logos">
                    <img :src="pic" alt="">
                </div>
                <div class="org-names" @click="toWeb">
                    <div class="Heading-Title" :style="'color:'+themColor">
                        <span class="Heading-Titlespan">
                            {{ipname}}
                        </span>
                        <div class="twoTitle">{{pinyinname}}</div>
                    </div>
                </div>
           </div>
           <div class="SearchBoxs">
                    <input type="text" class="SearchInput" :style="'border:1px solid'+$store.state.bgColor" placeholder="请输入关键字">
                    <button class="searchBtn" :style="'background-color:'+$store.state.bgColor">搜索</button>
                </div>
            <div class="qrcode" style="padding-top: 10px;box-sizing: border-box;">
                <img :src="qrcode" alt="">
            </div>
        </div>
        <div class="content">
            <div class="headNav" :style="'background-color:'+themColor">
                <div class="uls">
                    <router-link :to="{path:'/teamcontent/index',query: {orgId:orgId,name: 'first'}}" tag="li" class="docFam_li lis">
                        <span>首 页</span>
                    </router-link>
                    <div class="docFam_li lis" v-for="(item,index) in showModalList" :key="item.modulename" @mouseenter="ShowChile(item,index)" @mouseleave="closeChileMore" @click="checkout($event,item)">
                       <span><b class="Splitter">|</b>{{item.modulename}}</span>
                        <div class="childListBox" :style="'height:' + (titleTopidnumber==index ? 'auto;' : '0px;')">
                            <p v-for="items in item.children" class="ChildTitleBox" :key="items.modulename" @click="checkout($event, items)">{{ items.modulename }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lists"><router-view></router-view></div>
        </div>
        <div class="NewsModal">
                <h1 class="title">
                    <div class="TitleHeader" :style="'border-bottom: 3px solid'+$store.state.bgColor">友情链接</div>
                </h1>
                <div class="selectItem" >
                    <div v-for="(item, index) in urlList" :key="item.title" @mouseenter="ShowUrl(index)" @mouseleave="closeShowMore" class="selectype" :style="'border: 1px solid '+ $store.state.bgColor +';'">
                        <span class="type">{{ item.title }}</span>
                        <span class="down" :style="'border-top-color: '+ $store.state.bgColor +';'"></span>
                        <ul class="alltypes" :style="'height:' + (index==ShowNumber ? '200px;' : '0px;')">
                            <li v-for="items in item.childrenArr" :style="'color: '+ $store.state.bgColor +';'"  :key="items.url" class="linkClass"><span @click="openNew(items.url)">{{ items.title }}</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        <div class="footer" :style="'background-color:'+themColor">
            <div class="footerBox">
                <ul class="WebsiteInformation">
                    <li>地址：陕西省西安市高新区高新二路14号i创途众创公园A-108</li>
                    <li>联系电话：{{ phonenum }}</li>
                    <li>技术支持：西安阿科索健康科技有限公司</li>
                    <li>备案号：{{ icp }}</li>
                </ul>
            </div>
            <div style="flex: 1;">
               <div class="QrcodeBox" v-if="oneArr.length"><img class="QrcodeImg" :src="item" alt="" v-for="item in oneArr" :key="item"></div>
               <div class="QrcodeBox" v-if="twoArr.length"><img class="QrcodeImg" :src="item" alt="" v-for="item in twoArr" :key="item"></div>
               <!-- <div class="QrcodeBox"><img class="QrcodeImg" :src="item" alt="" v-for="item in QrCodeList" :key="item"></div> -->
            </div>
        </div>
        <!-- <div class="tip" :style="'width:' + (tipKey ? '250px;' : '0px;') + 'background-color:' + themColor"> pc端 暂未开放，请移步 移动端</div> -->
    </div>
</template>
<script>
export default {
    data(){
        return {
            tipKey: false,
            openKey: false,
            themColor: '#509d9f',
            token: '',
            titleTopidnumber: -1,
            orgId: '',
            ipname: '',
            ShowNumber: -1,
            QrCodeList: [],
            oneArr: [],
            twoArr: [],
            pic: '',
            urlList: [
                {
                    title: '国家技术部门网站',
                    childrenArr:[
                        {
                            title: '中华人民共和国国家卫生健康委员会',
                            url: 'http://www.nhc.gov.cn/'
                        },
                        {
                            title: '中国疾病预防控制中心',
                            url: 'http://www.chinacdc.cn/'
                        },
                        {
                            title: '国家医疗保障局',
                            url: 'http://www.nhsa.gov.cn/'
                        },
                        {
                            title: '中国健康教育',
                            url: 'http://www.zgjkjy.org/'
                        },
                        {
                            title: '国家中医药管理局政府网站',
                            url: 'http://www.satcm.gov.cn/'
                        },
                        {
                            title: '国家食品药品监督管理总局',
                            url: 'http://samr.cfda.gov.cn'
                        },
                        {
                            title: '中共中央网络安全和信息化委员会办公室',
                            url: 'http://www.cac.gov.cn'
                        },
                        {
                            title: '中华人民共和国国家卫生健康委员会',
                            url: 'http://www.nhc.gov.cn'
                        }
                    ]
                },
                {
                    title: '省级部门网站',
                    childrenArr:[
                        {
                            title: '陕西省疾病预防控制中心',
                            url: 'http://www.sxcdc.com/'
                        },
                        {
                            title: '陕西党建网',
                            url: 'http://www.sx-dj.gov.cn/'
                        },
                        {
                            title: '陕西省政府网',
                            url: 'http://www.shaanxi.gov.cn/'
                        },
                        {
                            title: '陕西省民政厅社会组织管理局',
                            url: 'http://mzt.shaanxi.gov.cn/html/zw/zcwj/shzz/index'
                        },
                        {
                            title: '陕西省药品监督管理局',
                            url: 'http://www.sxfda.gov.cn/'
                        },
                        {
                            title: '陕西省卫生健康委员会',
                            url: 'http://sxwjw.shaanxi.gov.cn'
                        }
                    ]
                },
                {
                    title: '医学健康网站',
                    childrenArr:[
                        {
                            title: '中国知网',
                            url: 'http://www.cnki.net/'
                        },
                        {
                            title: '医脉通',
                            url: 'http://www.medlive.cn/'
                        },
                        {
                            title: '医学百科',
                            url: 'https://www.wiki8.com/'
                        },
                        {
                            title: '维普',
                            url: 'http://www.cqvip.com/'
                        },
                        {
                            title: '医学会议 医学前沿',
                            url: 'http://www.9med.net/'
                        },
                        {
                            title: '健康报网',
                            url: 'http://www.jkb.com.cn/'
                        },
                        {
                            title: '新华健康',
                            url: 'http://www.xinhuanet.com/health/'
                        },
                        {
                            title: '生物谷',
                            url: 'http://www.bioon.com/'
                        },
                        {
                            title: '丁香园',
                            url: 'http://www.dxy.cn/'
                        },
                        {
                            title: '24小时医学频道',
                            url: 'http://www.24hmb.com/24/web/home'
                        },
                        {
                            title: '好大夫',
                            url: 'https://www.haodf.com'
                        },
                    ]
                },
                {
                    title: '其他相关网站',
                    childrenArr:[
                        {
                            title: '共产党员网',
                            url: 'http://www.12371.cn/'
                        },
                        {
                            title: '推荐评选身边的好医生好护士',
                            url: 'http://www.wenming.cn/sbhr_pd/sbhr_zghyshhs/?from=groupmessage&isappinstalled=0'
                        },
                        {
                            title: '学习强国',
                            url: 'https://www.xuexi.cn/'
                        },
                        {
                            title: '医学词典',
                            url: 'http://service.meddic.kydev.net/web/'
                        },
                        {
                            title: '医学计算',
                            url: 'http://service.medcalcs.kydev.net/web/'
                        },
                        {
                            title: '药品检索',
                            url: 'http://service.drugref.kydev.net/web/'
                        },
                        {
                            title: 'pubMed',
                            url: 'http://service.literature.kydev.net/web'
                        },

                    ]
                }
            ],
            time: '',
            icp: '陕ICP备19004145号-1',
            Website: '',
            showModalList: [],
            colorKey: false,
            qrcode: '',
            showPic: '',
            name: '',
            pinyinname: '',
            phonenum: '',
            othertoken: ''
        }
    },
    methods: {
        openMore(){
            this.openKey = true
        },
        closeMore(){
            this.openKey = false
        },
        ShowChile(item, index) {
            this.titleTopidnumber = index
        },
        ShowUrl(index) {
            this.ShowNumber = index
        },
        closeShowMore() {
            this.ShowNumber = -1
        },
        openNew(url) {
            window.open(url)
        },
        closeChileMore(){
            this.titleTopidnumber = -1
        },
        toLiTiXuJiao(){
            window.open('https://login.litixuanjiao.com/login')
        },
        open (){
            this.colorKey = !this.colorKey
        },
        changeColr(e){
            this.themColor = e
            this.$store.commit('changeBgColor',e)
        },
        checkout(event, item){
            event.stopPropagation();
            let { modulename, Remark, Moduletype } = item
            if(Moduletype == '外部链接'){
                window.open(Remark)
            }else{
                if(modulename == '留言区'){
                    this.tip()
                    return
                }
                this.$router.push({
                    path: '/teamcontent/index',
                    query:{
                        orgId: this.orgId,
                        name: modulename
                    }
                })
            }
          
        },
        tip(){
            let that = this
            this.tipKey = true
            setTimeout(() => {
                that.tipKey = false
            }, 1500);
        },
        getModalList() {
            var TOKEN = localStorage.getItem("TOKEN");
            var self = this;
            this.showModalList = []
            this.$axios.get("https://drplus.lotusdata.com/v1/studiomodule/list/" + this.orgId,{
                headers: {Authorization: TOKEN}
            }).then( res => {
                if (res.data.code == 0) {
                    var list = res.data.data;
                    let promises = list.map((item, index) => {
                        return getfirstactile(item, index);
                    });
                    function getfirstactile(item, index) {
                        return new Promise((resolve, reject) => { 
                            self.$axios.get("https://drplus.lotusdata.com/v1/article/contentbytags/" + self.orgId + "?key=" + item.Modulename + "&start=0&limit=5",{
                                headers: { Authorization: TOKEN }
                            }).then(res => {
                                if (res.data.code == 0) {
                                    var data = res.data.data;
                                    resolve({
                                        data: data,
                                        modulename: item.Modulename,
                                        moduleid: item.Moduleid,
                                        Id: item.Id,
                                        Top: item.Top,
                                        Sort: item.Sort,
                                        Remark: item.Remark,
                                        Moduletype: item.Moduletype,
                                        Parentid: item.Parentid
                                    });
                                }
                            });
                        });
                    }
                    Promise.all(promises)
                    .then(allData => {
                        let childrenArr = [],
                            Modellist = [],
                            showModalList = [];
                        allData.forEach(item => {
                            if (item.data!=null&&item.modulename !== '新闻/通知'&&item.Top === '1'&&item.Parentid=='0') {
                                showModalList.push({
                                    modulename: item.modulename,
                                    id: item.Id,
                                    Parentid: item.Parentid,
                                    Moduletype: item.Moduletype,
                                    Remark: item.Remark,
                                    list: item.data,
                                    children: []
                                });
                                Modellist.push(item.moduleid)
                            }else if (item.modulename !== '新闻/通知'&&item.Top === '1'&&item.Parentid=='0'&&item.Moduletype=='外部链接') {
                                showModalList.push({
                                    modulename: item.modulename,
                                    id: item.Id,
                                    Parentid: item.Parentid,
                                    Moduletype: item.Moduletype,
                                    Remark: item.Remark,
                                    list: item.data,
                                    children: []
                                });
                                Modellist.push(item.moduleid)
                            }else if(item.data != null && item.modulename !== '新闻/通知'&&item.Top === '1') {
                                childrenArr.push({
                                    modulename: item.modulename,
                                    id: item.Id,
                                    Parentid: item.Parentid,
                                    Moduletype: item.Moduletype,
                                    Remark: item.Remark,
                                    list: item.data,
                                })
                            }
                        });
                        childrenArr.forEach(v=>{
                            let index = Modellist.indexOf(v.Parentid)
                            if(index != -1) {
                                showModalList[index].children.push(v)
                            }
                        })
                        this.showModalList = showModalList
                    }).catch(err => {
                        console.log(err);
                    });
                }
            },
            function() {
                console.log("数据请求失败");
            });
        },
        getorgInfo() {
            var TOKEN = localStorage.getItem("TOKEN");
            this.$axios
                .get("https://api.lotusdata.com/ip/v1/ipm/" + this.orgId, {
                headers: {
                    Authorization: TOKEN
                }
                })
                .then(
                res => {
                    if (res.data.code == 0) {
                    var infodata = res.data.data;
                    this.ipname = infodata.Ipname;
                    this.pic = infodata.Pic;
                    }
                },
                function() {
                    console.log("数据请求失败");
                }
            );
        },
        getOther(){
            var that = this,
                token = that.othertoken;
            this.$axios.get('https://api.lotusdata.com/operations/v1/organization/'+ that.orgId,{
                headers: { Authorization: token }
            }).then( res => {
                if(res.data.code == '0' && res.data.data != null){
                    var data = res.data.data
                    this.themColor = data.theme
                    this.$store.commit('changeBgColor',data.theme || '#509d9f')
                    that.Website = data.Website
                    that.showPic = data.Photo
                    that.pinyinname = data.PinYinName
                    that.phonenum = data.Telephone
                    if(data.icp){
                        that.icp = data.icp
                    }
                    if(data.qrcode){
                        let QrCodeList = JSON.parse(data.qrcode)
                        this.QrCodeList = QrCodeList
                        let arrNumber = QrCodeList.length
                        let halfNumber = Math.floor(arrNumber/2)
                        let oneArr = QrCodeList.slice(0, halfNumber)
                        let twoArr = QrCodeList.slice(halfNumber, arrNumber)
                        this.oneArr = oneArr
                        this.twoArr = twoArr
                    }
                }
            })
            this.$axios.post('https://api.lotusdata.com/v1/wx/wxapppagecode?appid=wxb749c5b8e8473763', {"scene": this.orgId, "page": "page/department/department"},{
                headers: { Authorization: localStorage.getItem("TOKEN") }
            }).then(res => {
                if (res.data.code == '0') {
                    this.qrcode = res.data.data;
                }
            })
        },
        getLoginToken() {
            var data = {
                username: "uuapp2",
                password: "123123",
                refreshtoken: "0"
            };
            var that = this;
            this.$axios
                .post(
                "https://api.lotusdata.com/operations/v1/admlogin/token",
                data,
                {}
                )
                .then(function(res) {
                    that.othertoken = "JWT " + res.data.token;
                    localStorage.setItem("token", that.othertoken);
                    that.getOther()
                });
        },
        toWeb(){
            if(this.Website == ''){
                this.$router.push({
                    path:'/teamcontent/index',
                    query: {orgId:this.orgId,name: 'first'}
                })
            } else {
                location.href = this.Website;
            }
        },
        getToken(){
            this.$axios.get("https://api.lotusdata.com/v1/buser/token", {
                params: {
                    username: "uuapp.li@qq.com",
                    password: "123123",
                    refreshtoken: 0
                }
            }).then( res => {
                if (res.data.code == 0) {
                    var TOKEN = res.data.token;
                    this.token = TOKEN
                    localStorage.setItem("TOKEN", "JWT " + TOKEN);
                    this.getorgInfo()
                    this.getModalList()
                    // localStorage.setItem("TOKEN", "JWT " + TOKEN);
                }
            },function() {
                console.log("数据请求失败");
            });
        },
        toKnew(){
            this.$router.push({
                path:'/teamcontent/index',
                query: {
                    orgId: this.orgId,
                    name: '新闻/通知'
                    }
                })
        },
        toKnow (){
            this.$router.push({
                path:'/teamcontent/knowledge',
                query: {
                    orgId: this.orgId,
                    name: 'first'
                    }
                })
        }
    },
    mounted () {
        var that = this;
        window.onpopstate = function(event) {
            // URL参数变化的处理逻辑
            console.log(event)
        };
        that.orgId = that.$route.query.orgId;
        that.name = that.$route.query.name;
        runloop();
        function runloop () {
            var token = localStorage.getItem('TOKEN');
            that.getToken()
            that.getLoginToken()
        }
        getTime();
        function getTime () {
            var date = new Date();
            that.time = date.getFullYear()+"年"+(date.getMonth()+1)+"月"+date.getDate()+"日";
            var hours = date.getHours(),
                minites = date.getMinutes(),
                seconds = date.getSeconds();
            var week = '';
            if (date.getDay() == 1) {
                week = '星期一';
            }
            if (date.getDay() == 2) {
                week = '星期二';
            }
            if (date.getDay() == 3) {
                week = '星期三';
            }
            if (date.getDay() == 4) {
                week = '星期四';
            }
            if (date.getDay() == 5) {
                week = '星期五';
            }
            if (date.getDay() == 6) {
                week = '星期六';
            }
            if (date.getDay() == 0) {
                week = '星期天';
            }
            that.time = that.time + ' ' + week + ' ' + (hours < 10 ? '0' + hours : hours) +": "+ (minites < 10 ? '0' + minites : minites) + ": " + (seconds < 10 ? '0' + seconds : seconds);
        }
        // that.toIndex()
        this.timefunc = setInterval(getTime, 1000);
    },
    watch: {
        '$route' (to, from) {
            if(to.name == 'index'){
                var orgId = this.$route.query.orgId,
                    name = this.$route.query.name ? '' : 'first'
                if( this.orgId != orgId){
                    this.orgId = orgId
                    this.getModalList()
                    this.getOther()
                    this.getorgInfo()
                }else{
                    this.name = name
                }
            }
        },
    },
    beforeDestroy () {
        clearInterval(this.timefunc);
    },
}
</script>
<style scope lang="scss">
    ul{
        list-style: none;
        padding: 0;
    }
    .NewsModal{ // 相关栏目
            width: 1400px;
            margin: 0 auto;
            margin-top: 30px;
            .title{
                display: flex;
                justify-content: space-between;
                margin: 0;
                border-bottom: 1px solid #888;
                line-height: 50px;
                .moreBox{
                    font-size: 15px;
                    cursor: pointer;
                }
                .TitleHeader{
                    height: 50px;
                    box-sizing: border-box;
                    border-bottom: 3px solid #888;
                }
            }
            .selectItem{
                width: 100%;
                height: 40px;
                justify-content: space-around;
                display: flex;
                position: relative;
                border-radius: 5px;
                margin-top: 20px;
                .selectype{
                    padding: 0 10px;
                    line-height: 40px;
                    border-radius: 3px;
                    height: 40px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    cursor: pointer;
                    background-color: #fff;
                    position: relative;
                    .alltypes{
                        font-size: 12px;
                        background: #fff;
                        margin: 0;
                        position: absolute;
                        top: 40px;
                        width: 100%;
                        list-style: none;
                        padding: 0 5px;
                        line-height: 30px;
                        height: 200px;
                        left: 0;
                        overflow:scroll;
                        box-sizing: border-box;
                        border-right: 1px solid;
                        border-left: 1px solid;
                        border-bottom: 1px solid;
                        border-color: #eee;
                        .linkClass{
                            color: #509d9f
                        }
                       
                    }
                    .alltypes::-webkit-scrollbar {
                        width: 0em; /* 设置滚动条的宽度为0.5em */
                        display: none;
                    }
                    .type{
                        margin-right: 120px;
                        font-size: 12px
                    }
                    .down{
                        width: 0;
                        height: 0;
                        display: inline-block;
                        border: 4px solid transparent;
                    }
                }
            }
    }
    .wrapper {
        width: 100%;
        height: auto;
        position: relative; 
        .top{
            width:100%;
            height: 40px;
            line-height: 40px;
            background-color: #eee;
           .topContainer{
                width: 1140px;
                height: 100%;
                font-size:16px;
                margin: 0 auto;
                .right{
                    float: right;
                    width: 100px;
                    height: 100%;
                    .loginAdmin{
                        // border: 1px solid black;
                        padding: 5px 10px;
                        font-size: 14px;
                        border-radius: 2px;
                        cursor: pointer;
                        color: #fff;                    
                    }
                    .loginAdmin:hover{
                        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 
                                    0 0 6px rgba(0, 0, 0, .04);
                    }
                }
            }

        }
        .header {
            position: relative;
            padding: 0px;
            width: 1400px;
            height: 100px;
            display: flex;
            margin: 0 auto;
            .SearchBoxs{
                flex: 1;
                height: 100px;
                padding: 30px 0;
                box-sizing: border-box;
                .searchBtn{
                    width: 90px;
                    height: 100%;
                    line-height: 100%;
                    border-radius: 20px;
                    color: #fff;
                    border: 0px;
                    font-size: 14px;
                    background-color: #3e8f83;
                    outline: none;
                    cursor: pointer;
                }
                .SearchInput{
                    width: 280px;
                    height: 100%;
                    background-color: #f7f7f7;
                    border: 1px solid #e7e7e7;
                    padding-left: 20px;
                    border-radius: 20px;
                    margin-right: 15px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                }
            }
            .leftHeader {
                flex: 1;
                display: flex;
                height: auto;
                .org-logos{
                    height: 100px;
                    padding-right: 10px;
                img{
                    height: 100px;
                    border-radius: 15px;
                    height: 100px;
                }
            }
            .org-names {
                // width: 600px;
                line-height: 90px;
                font-weight: bold;
                display: block;
                font-size: 28px;
            }
            }
            .pin-yin{
                color:#c3c3c3;
                opacity: 0.9;
                font-size: 16px;
                line-height: 0px;
                margin-top: -10px;
                display: block;
                font-family: "Times New Roman";
            }
            .Heading-Title{
                display: block;
                line-height: 40px;
                height: 100px;
                padding-top: 30px;
                /* padding-left: 1px; */
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                .twoTitle{
                    font-size: 16px;
                    font-family: cursive;
                    color: rgb(136, 136, 136);
                    line-height: 20px;
                    letter-spacing: 8px;
                    display: block;
                }
            }
            .Heading-Titlespan{
                letter-spacing: 4px;
            }
            .Heading-Titlespan::after {
                position: absolute;  
                top: 0;  
                right: 0;  
                bottom: 0;  
                left: 0;  
                background-color: rgba(0, 0, 0, 0.8); /* 黑色遮罩，50%透明 */  
                z-index: 10; /* 将遮罩放在实际内容的下方 */  
            }  
            .org-names:hover{
                cursor: pointer;
                color: #c3c3c3;
            }

            .qrcode{
                width: 100px;
                height: 90%;
                display: flex;
                align-items: center;
                .text{
                    font-size: 12px;
                    height: 20px;
                    margin-left: 20px;
                    img{
                        height: 100%;
                        width: 20px;
                    }
                    span{
                        width: 200px;
                        vertical-align: top;
                    }
                }
                img{
                    height: 100%;
                    vertical-align: middle;
                }
            }
        }
        .footer{
            min-height: 180px;
            margin-top: 2%;
            font-size: 14px;
            justify-content: space-around;
            display: flex;
            padding: 20px;
            box-sizing: border-box;
            .footerBox{
                display: flex;
                margin: 0 auto;
                width: 400px;
                margin-right: 20px;
                color: #fff;
                justify-content: space-between;
                align-items: center;
            }
            .QrcodeBox{
                flex: 1;
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                padding: 5px 0px;
                .QrcodeImg{
                    width: 100px;
                    height: 100px;
                }
            }
        }
        .content{
            width: 100%;
            .headNav{
                width: 100%;
                height: 50px;
                line-height: 50px;
                color: #fff;
                background-color: #509d9f;
                .uls{
                    list-style: none;
                    margin: 0 auto;
                    width: 1440px;
                    display: flex;
                    height: 100%;
                    .lis{
                        height: 100%;
                        color: #fff;
                        display: inline-block;
                        width: 120px;
                        text-align: center;
                        cursor: pointer;
                        height: 50px;
                        line-height: 50px;
                        position: relative;
                        .Splitter{
                            font-size: 12px;
                            display: block;
                            position: absolute;
                        }
                        .childListBox{
                            position: absolute;
                            top: 50px;
                            left: 0px;
                            color: #fff;
                            transition: height 0.5s ease-in-out; 
                            overflow: hidden;
                            width: 120px;
                            // height: 500px;
                            // background: #000;
                            z-index: 9999;
                            li{
                                height: 50px;
                                line-height: 50px;
                            }
                            .ChildTitleBox{
                                background-color: rgba(0, 0, 0, .6)
                            }
                            .ChildTitleBox:hover{
                                color: #fff;
                                background-color: rgba(0, 0, 0, .9);
                                opacity: 1;
                            }
                            .ChildTitleBox::before {
                                content: "";  
                                position: absolute;  
                                top: 0;  
                                right: 0;  
                                bottom: 0;  
                                left: 0;  
                                background-color: rgba(0, 0, 0, 0.1); /* 黑色遮罩，50%透明 */  
                                z-index: -1; /* 将遮罩放在实际内容的下方 */  
                            }
                        }
                    }
                    .lis:hover {
                        // background-color: #afbebe;
                        cursor: pointer;
                        color: #fff;
                        z-index: 100;
                    }
                    .lis::before {
                        content: "";  
                        position: absolute;  
                        top: 0;  
                        right: 0;  
                        bottom: 0;  
                        left: 0;  
                        background-color: rgba(0, 0, 0, 0.1); /* 黑色遮罩，50%透明 */  
                        z-index: -1; /* 将遮罩放在实际内容的下方 */  
                    }
                    .right {
                        // line-height: 13px;
                        img{
                            margin-top: 3px;
                            // display: block;
                            height: 30px;
                        }
                        span{
                            display: inline-block;
                            width: 100%;
                        }
                        float: right;
                        font-size: 12px;
                    }
                    .more-module{
                        position: relative;
                        .more-list{
                            top: 35px;
                            overflow: hidden;
                            position: absolute;
                            width: 100px;
                            background-color: #509d9f;
                            z-index: 20;
                            p:hover{
                                background-color: #afbebe;
                            }
                        }
                    }
                    .more-module::after{
                        content:  '';
                        position: absolute;
                        top: 13px;
                        right: 10px;
                        border: 8px solid #fff;
                        border-left-color: transparent;
                        border-right-color: transparent;
                        border-bottom-color: transparent;
                    }
                }
            }

        }
        .lists{
            min-height: 80vh;
            width: 100%;
        }
        .tip{
            // border: 1px solid #fff;
            border-radius: 2px;
            position: absolute;
            top: -30%;
            right: 0;
            color: #fff;
            left: 0;
            bottom:0;
            margin: auto;
            width: 0px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            overflow: hidden;
            transition: width .2s ease-in-out;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/teamlist/teamHome.vue